"use strict";
/**
 * The Parallel card's quick-add: the primary's sibling markets, each one tap
 * from an inverted parallel leg (ai/PARALLEL_LEGS_PLAN.md §4).
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_SIBLINGS = void 0;
exports.siblingMarkets = siblingMarkets;
exports.siblingLeg = siblingLeg;
const parallel_markets_service_1 = require("../services/parallel-markets-service");
/** Enough for a game's teams and draw; a long ladder of lines is the modal's job. */
exports.MAX_SIBLINGS = 8;
function isLegVenue(venue) {
    return venue in parallel_markets_service_1.PARALLEL_VENUE_TAGS;
}
/**
 * The event's other markets of the primary's type, minus attached legs.
 * Kalshi markets carry no type; a Kalshi event's markets are one type already.
 */
function siblingMarkets(primary, available, attached) {
    if (!primary)
        return [];
    return available
        .filter((m) => m.id !== primary.id &&
        isLegVenue(m.venue) &&
        m.marketCategory === primary.marketCategory &&
        !attached.some((leg) => leg.marketId === m.id && leg.venue === m.venue))
        .slice(0, exports.MAX_SIBLINGS);
}
/** The leg a quick-add tap attaches: the sibling's opposite side. */
function siblingLeg(market, eventTicker) {
    return {
        marketId: market.id,
        marketTitle: market.title,
        eventTicker,
        venue: market.venue,
        invert: true,
        sideNames: [market.yesSubtitle ?? market.outcomes?.[0] ?? "", market.noSubtitle ?? market.outcomes?.[1] ?? ""],
        ...(market.novigOutcomeIds ? { novigOutcomeIds: market.novigOutcomeIds } : {}),
    };
}
